// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CREATE_INFO_CUSTOMER_PAYMENT, GET_INFO_CUSTOMER_PAYMENT, GET_INFO_CUSTOMER_PAYMENT_DONE, GET_LIST_BANK, GET_LIST_BANK_BRANCH, GET_LIST_BANK_BRANCH_DONE, GET_LIST_BANK_DONE } from "./constant";

export const GetInfoCustomerPayment = (payload?: any, callback?: CallBackActionITF) => {
  return {
    type: GET_INFO_CUSTOMER_PAYMENT,
    payload,
    callback
  };
};

export const GetInfoCustomerPaymentDone = (data: any) => ({
  type: GET_INFO_CUSTOMER_PAYMENT_DONE,
  payload: data
})

export const GetListBank = (payload?: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_BANK,
    payload,
    callback
  };
};

export const GetListBankDone = (data: any) => ({
  type: GET_LIST_BANK_DONE,
  payload: data
})

export const GetListBankBranch = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_BANK_BRANCH,
    payload,
    callback
  };
};

export const GetListBankBranchDone = (data: any) => ({
  type: GET_LIST_BANK_BRANCH_DONE,
  payload: data
})

export const PostNewInfoCustomerPayment = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: CREATE_INFO_CUSTOMER_PAYMENT,
    payload,
    callback
  };
};